import type { PriceVO } from '@ctct/domain-layer';
import type { ApplePayPaymentData } from '@ctct/infrastructure-layer';

import { EventBus } from '../../helpers';

type OrderSummaryEvents = {
  editAddOnClicked: [addOnId: string];
  editPlanClicked: [planId: string];
  addOnRemoved: [addOnId: string];
  smsBundleTierEditClicked: [];
  totalPriceUpdated: [totalPriceLabel: string];
  paymentDataUpdated: [paymentData: Omit<ApplePayPaymentData, 'label'>];
  ratingCallPending: [isPending: boolean];
  balanceUpdated: [balance: PriceVO];
  planBaseMonthlyPriceUpdated: [{ value: PriceVO; currency: string }];
};

class OrderSummaryEventBus extends EventBus<OrderSummaryEvents> {}

export const orderSummaryEventBus = new OrderSummaryEventBus();
